import styled from 'styled-components';

export const Container = styled.div`
  
`;
export const Section = styled.div`
  
`;
export const Subtitle = styled.div`
  
`;

export const Title = styled.span`
  color: ${props => props.theme.colors.text};
  font-weight: 700;
  font-size: 18px;
`;